


















import { Component, Prop, Vue } from 'vue-property-decorator';

// TODO: refactor this component and use in all places, currently styles applies from this file
// update to scoped after it.
@Component
export default class Input extends Vue {
  @Prop({ default: '' }) value!: string;
  @Prop({ default: '' }) placeholder!: string;
  @Prop({ default: false }) required!: boolean;
  @Prop({ default: 'text' }) type!: 'text' | 'number'
  @Prop({ default: false }) area!: boolean;

  get localPlaceholder () {
    const { placeholder, required } = this;
    if (placeholder && required) {
      return `* ${placeholder}`;
    }
    return placeholder;
  }

  handleInput (v: string) {
    this.$emit('input', v);
  }
}
